<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <div>
                    <app-saved-dashboard-view></app-saved-dashboard-view>
                </div>
                <div *ngFor="let link of [modify_time_users_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <app-filter-selector
                    [filterDashboardItemLinks]="filterDashboardItemLinks"
                ></app-filter-selector>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>
        <div class="main-container">
            <div class="grid-container">
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="12" *ngFor="let link of [users]">
                        <app-table-dashboard-item
                            [dashboardItem]="link.dashboardItem"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-table-dashboard-item>
                    </div>
                    <div nz-col nzSpan="12" *ngFor="let link of [revenue]">
                        <app-table-dashboard-item
                            [dashboardItem]="link.dashboardItem"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-table-dashboard-item>
                    </div>
                </div>
            </div>

            <nz-divider
                nzText="Selected devices details"
                nzOrientation="left"
            ></nz-divider>
            <div class="grid-container">
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [selected_devices]"
                    >
                        <app-table-dashboard-item
                            [dashboardItem]="link.dashboardItem"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-table-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [device_revenue_country]"
                    >
                        <app-table-dashboard-item
                            [dashboardItem]="link.dashboardItem"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-table-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [selected_device_daily_users]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [selected_device_daily_revenue]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="
                            let link of [
                                selected_devices_daily_users_by_device_model,
                            ]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="
                            let link of [
                                selected_device_daily_revenue_by_country,
                            ]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
